module.exports = __webpack_public_path__ + "img/46_6.fc1ec34d.png";